export default {
    "languages": {
        "russian": "Русский",
        "english": "Английский",
        "kazakh": "Казахский"
    },
    "common": {
        "yes": "Да",
        "no": "Нет",
        "success": "Успешно",
        "guest": "Гость",
        "back": "← Назад",
        "now": "Сейчас",
        "aMinuteAgo": "минуту назад",
        "cancel": "Отмена",
    },
    "signin": {
        "signIn": "Войти",
        "welcomeBack": "Добро пожаловать !",
        "introText": "Diffuzio: твой умный помощник в социальных сетях.",
        "emailLabel": "Адрес электронной почты",
        "inputPassword": "Введите пароль",
        "passwordLabel": "Пароль",
        "forgotPassword": "Забыли пароль ?",
        "dontHaveAccount": "У вас нет аккаунта?",
        "or": "или",
        "continue": "Продолжить",
        "signInEmail": "Войти по почте",
        "signInGoogle": "Войти через Google",
        "signInApple": "Войти через Apple",
        "signInFacebook": "Войти с помощью Facebook",
        "signInInstagram": "Войти с помощью Instagram",
        "signInLinkedIn": "Войти с помощью LinkedIn",
        "linkFacebook": "Привязать страницу Facebook",
        "linkLinkedIn": "Привязать аккаунт LinkedIn",
        "linkInstagram": "Привязать аккаунт Instagram",
        "linkedFacebook": "Facebook привязан",
        "linkedInstagram": "Instagram привязан",
        "unlinkedLinkedIn": "Отвязать LinkedIn",
        "unlinkedFacebook": "Отвязать Facebook",
        "unlinkedInstagram": "Отвязать Instagram",
        "privacy": "Условия <offerLink>Публичной оферты</offerLink> и <privacyLink>Политики конфиденциальности</privacyLink> мною прочитаны полностью, все условия мне понятны, со всеми условиями я согласен",
        "payment": "Порядок оплаты",
        "contacts": 'WhatsApp: +7 700 600 0001 \r\n Email: info@diffuz.io',
        "agreePrivacy": "Выберите, пожалуйста, “☑” галочку напротив текста касательно ознакомления и согласия с Публичной офертой и Политикой.",
        "privacyTitle": "Политика конфиденциальности",
        "offerTitle": "Публичная оферта",
        "chooseLang": "Выберите удобный для себя язык",
        "howThatWorkingBtn": "Как это работает?",
        "welcomeModalTitle": "Добро пожаловать в DIFFUZ.IO",
        "welcomeModalText": "Если Вы здесь впервые и не знаете как работает наш сервис можете нажать на кнопку \"Попробовать\" что-бы опробовать демо версию нашего приложения без авторизации либо нажмите на \"Авторизоваться\" что бы войти в свою учетную запись",
        "welcomeModalOkBtn": "Попробовать",
        "welcomeModalCancelBtn": "Авторизоваться",
        "login": "Вход",
        "submitSign": "Войдите в свой аккаунт, используя аккаунт Google или адрес электронной почты.",
    },
    "signup": {
        "signUp": "Зарегистрироваться",
        "fullName": "Полное имя",
        "passwordRequirements": "Убедитесь, что Ваш пароль содержит не менее 8 символов: 1 заглавную, 1 строчную, 1 цифру и 1 специальный символ.",
        "haveAccount": "У Вас уже есть аккаунт?",
        "signUpGoogle": "Зарегистрируйтесь через Google",
        "signUpApple": "Зарегистрируйтесь через Apple",
        "signUpFacebook": "Зарегистрируйтесь через Facebook",
        "signUpLinkedIn": "Зарегистрируйтесь через LinkedIn",
        "lang": "Язык",
        "submitSign": "Отправьте запрос на вход, и мы свяжемся с вами как можно скорее.",
        "continue": "Продолжить",
        "copyrights": "© 2025 Diffuzio Все права защищены",
        "acceptPolicy": "Принять политику и правила",
    },
    "welcome": {
        "welcome": "Добро пожаловать,{{username}}, в Diffuzio!",
        "howWeWork": "Как мы работаем",
        "completeSurvey": "Создание персонализированных постов \n начинается с четко продуманной стратегии.",
        "completeSurvey2": "Эта стратегия станет основой \n для контент-плана и публикаций, \n отражающих ваши цели и предпочтения.",
        "proceed": "Перейти к опросу",
        "warning": "Очень важно максимально полно ответить на вопросы, чтобы стратегия была приближена к вашим ожиданиям.",
        "warning2": "В процессе нашего с Вами взаимодействия мы ее скорректируем, с нашей точки зрения, для более точной персонализации.",
        "verifyEmailTitle": "Подтвердите свою почту",
        "verifyEmailText": "Введите код из письма, чтобы подтвердить свою почту",
        "resendVerifyCode": "Получить новый код",
        "resendVerifyCodeSuccess": "Код успешно отправлен",
        "verifyEmailSuccess": "Почта успешно подтверждена",
        "verifyEmailError": "Ошибка! Возможно был введен неверный код",
    },
    "assistant": {
        "header": "Ассистент",
        "title": "Ваш персональный ассистент",
        "getSupport": "Помощь",
        "send": "Отправить",
        "shortcutSend": "Отправить: Ctrl+Enter",
        "shortcutPaste": "Вставить: Ctrl+V",
        "emptyChat": "Нет сообщений",
        "pleaseWaitForResponse": "Пожалуйста подождите. Готовлю ответ...",
        "assistantInfo": "Ассистент может допускать ошибки. Рекомендуем проверять важную информацию.",
        "helloMessage": "Здравствуйте!\nЯ Ваш ассистент и готов помочь в разных ситуациях: подготовить или ответить на письмо,\nподелиться последними новостями, рассказать шутку или даже сделать перевод. Я здесь, чтобы поддержать\nВас в работе, бизнесе и во многих других вопросах. Чем могу помочь?",
        "textToGeneratePostFromAssistantMessage": "Сгенерируй пост на основе этого сообщения с минимальными изменениями",
        "createPostFromThisMessageBtn": "Создать пост на основе этого сообщения",
        "createsSeriesPostsFromThisMessageBtn": "Создать серию постов на основе контекста этого сообщения",
        "addNewPostToSeries": "Добавить новый пост в серию",
        "notEnoughPosts": "Не хватает постов для создания серии",
        "deleteSeriesElement": "Вы действительно хотите удалить данный элемент серии?",
        "createPostSuccess": "Пост №{{count}} успешно сгенерирован!",
        "createPostError": "Ошибка при создании поста №{{count}}",
        "postTitlePrefix": "Пост из серии №",
        "chatSettingsTitle": "Настройки чата",
        "useYourFile": "Использовать Ваш файл",
        "useEmployeeFile": "Использовать файл сотрудника",
        "useInternetSearch": "Использовать поиск в интернете",
        "useInternetSearchingConfirm": "Пожалуйста, убедитесь, что для публикации постов через ассистента в настройках ассистента отключено использование интернета.",
        "assistantWarningInfo": "Необходимо загрузить файл для доступа к данной функции",
        "assistantMakeQuestionsPopoverTitleTrue": "Создать наводящие вопросы (Включено)",
        "assistantMakeQuestionsPopoverTitleFalse": "Создать наводящие вопросы (Выключено)",
        "assistantMakeQuestionsPopoverContent": "Включите что бы Ассистент создал Вам наводящие вопросы по вашей теме.",
        "assistantQuickFilePopoverTitleEmpty": "Быстрый файл",
        "assistantQuickFilePopoverTitle": "Прикрепленный файл",
        "assistantQuickFilePopoverInfo": "Вы можете прикрепить один быстрый файл к Вашему сообщению для более релевантного ответа либо аналитики содержимого файла.",
        "assistantSettingsInstructionTitle": "Тестовый режим обучения ассистента.",
        "assistantSettingsInstructionContent": "Предоставьте информацию ассистенту, которую он изучит для взаимодействия с вами. (Помимо этого режима у продвинутого ассистента скоро будут дополнительно очень крутые фишки).",
        "assistantFilesInstructionTitle": "Инструкция для использования ассистента",
        "seriesPostsInstruction": "Теперь вы можете создавать серию связанных постов на одну тему. Каждый пост будет логическим продолжением предыдущего, формируя единую структуру.\n" +
            "После генерации вы можете редактировать каждый пост с помощью ассистента до тех пор, пока серия полностью не устроит вас.\n" +
            "Когда всё будет готово — отправьте серию в раздел «Создать публикацию» для дальнейшей работы и планирования.",
        "seriesPostsFromArrayInstruction": "Теперь Вы можете создавать публикации напрямую через Ассистента. Понравившиеся Вам тексты — будь то отдельные посты или целые серии взаимосвязанных публикаций — можно мгновенно отправлять на размещение.",
        "assistantFilesInstructionContent": `Вы можете предоставить информацию для ассистента, который изучит ее и будет использовать при взаимодействии с вами. Для этого выполните следующие шаги:
1. Подготовьте файл в формате Word (.doc или .docx), содержащий информацию, которую ассистент должен учитывать.
2. Если Вы хотите добавить новые данные к уже имеющимся, внесите новые сведения в тот же файл, сохранив всю ранее добавленную информацию.
3. Загрузите файл через соответствующий раздел сервиса.
После обработки информации ассистент начнет использовать её в своих ответах и рекомендациях.`,
        "assistantFilesInstructionEmployeeContent": "Вы можете предоставить информацию для ассистента, который будет использоваться при взаимодействии с вами. \n" +
            "\n" +
            "Для этого выполните следующие шаги:\n" +
            "1.⁠ ⁠Подготовьте файл в формате Word (.doc или .docx), содержащий информацию, которую ассистент должен учитывать.\n" +
            "2.⁠ ⁠Если Вы хотите добавить новые данные к уже имеющимся, Вам надо загрузить файл с добавленной информацией.",
        "assistantInternetSearchInstructionTitle": "Инструкция по использованию интернет-запросов в ассистенте",
        "assistantInternetSearchInstructionContent": "Теперь у Вас есть возможность использовать интернет-запросы в ассистенте и получать актуальную информацию из сети.\n" +
            "\n" +
            "Как включить интернет-запросы?\n" +
            " 1. Активируйте галочку “Использовать интернет” в настройках ассистента.\n" +
            " 2. После активации все последующие запросы в течение текущей сессии будут использовать интернет для подготовки ответов.\n" +
            "\n" +
            "Важные ограничения\n" +
            " 1. Доступ к интернету активен только во время текущей сессии. При следующем входе в сервис галочку нужно включить заново.\n" +
            " 2. Ответ может занять немного больше времени, так как информация загружается в реальном времени.",
        "uploadFile": "Загрузить файл",
        "uploadNewFile": "Обновить файл",
        "yourHaveFile": "У Вас есть загруженный файл.",
        "confirm": "Подтвердить",
        "fileUploadSuccess": "Файл успешно загружен!",
        "post": {
            "postTitle": "Пост",
            "generateImageLimitExceeded": "Превышен лимит генерации изображений для поста (3 попытки)."
        },
        "postThemePlaceholder": "Введите тему поста",
        "postContentPlaceholder": "Введите текст поста",
        "postHashtagsPlaceholder": "Введите хештеги для поста",
        "required": "Обязательно",
        "getLeadingQuestions": "Получить наводящие вопросы",
        "waitLeadingQuestions": "Подготавливаю вопросы",
        "seeLeadingQuestions": "Открыть наводящие вопросы",
        "yourAnswerFromQuestionLabel": "Ваш ответ на вопрос",
        "moveLeadingQuestionsToChatMessage": "Перенести вопросы в чат",
        "moveLeadingAnswersToChatMessage": "Перенести ответы в чат",
        "reviseAnswer": "Скорректировать ответ",
        "leadingQAPrompt1": "Вопрос {{count}} «{{question}}»\nи ответ пользователя: «{{answer}}»\n\n",
        "leadingQAPrompt2": "Внеси дополнения в пост №{{PostId}} «{{postContext}}» с учетом ответа пользователя на вспомогательные вопросы по теме поста:\n{{prompt}}\nОстальные посты из этих постов не меняй, предоставь в ответе все посты",
        "startRecording": "Начать запись",
        "stopRecording": "Остановить запись",
        "getAnswer": "Получить ответ",
        "waitAnswer": "Подготавливаю ответ",
        "reGetAnswer": "Получить новый ответ",
        "yourMessage": "Ваше сообщение",
        "answerWithNumber": "Ответ {{count}}: {{answer}}",
        "warningInternetSearchModalTitle": "Внимание!",
        "warningInternetSearchModalText": "В данный момент у Вас включена функция поиска в интернете в настройках ассистента. Если Вы планируете использовать генерацию постов, рекомендуем временно отключить эту функцию, чтобы обеспечить корректную работу ассистента.",
        "warningInternetSearchModalSkipBtn": "Продолжить без изменений",
        "warningInternetSearchModalAgreeBtn": "Отключить поиск",
        "sendChatMessageErrorText": "Предыдущий запрос всё ещё в обработке. Пожалуйста, подождите несколько минут. Если проблема не исчезнет, напишите, пожалуйста, в Техническую поддержку.",
        "useInternetSearchingConfirmTitle": "Напоминание",
    },
    "system_messages": {
        "request_for_editing_post": "⌬ Запрос на редактирование поста",
        "request_for_editing_post_with_info": "⌬ Регенерация поста №{{postNumber}} с учетом ответов:\n\n{{text}}",
    },
    "profile": {
        "shareLocationExplanation": "Укажите приблизительное местоположение (город/страна) для улучшения планирования.",
        "socialConnectionsTitle": "Привязка социальных сетей",
        "hintConnectLinkedIn": "Подключите свой LinkedIn для публикации",
        "hintConnectFacebook": "Подключите свою бизнес-страницу Facebook",
        "hintConnectInstagram": "Подключите свой аккаунт Instagram Business",
        "hintConnectThreads": "Подключите Threads, чтобы планировать публикации",
        "hintFacebookHelp": "Подключите бизнес-страницу Facebook для публикации. Следуйте инструкциям ниже.",
        "hintInstagramHelp": "Убедитесь, что ваш аккаунт Instagram является бизнес-аккаунтом, подключенным к странице Facebook.",
        "unlinkLinkedinConfrim": "Вы действительно хотите отвязать свой аккаунт LinkedIn?",
        "unlinkFacebookConfrim": "Вы действительно хотите отвязать свой аккаунт Facebook?",
        "unlinkInstagramConfrim": "Вы действительно хотите отвязать свой аккаунт Instagram?",
        "unlinkThreadsConfirm": "Вы действительно хотите отвязать свой аккаунт Threads?",
        "openFBDocsTitle": "Открыть инструкцию",
        "noPagesFB": "Нет страниц в Facebook",
        "noPagesLinkedIn": "Нет страниц в LinkedIn",
        "cancelDelete": "Отменить удаление",
        "accountWillBeDeleted": "Ваш аккаунт будет удалён",
        "recoverAccount": "Отменить удаление",
        "removeAccountBtn": "Удалить аккаунт",
        "yesRemoveAccount": "Да, удалить",
        "notRemoveAccount": "Нет, не удалять",
        "removeAccountTitle": "Вы действительно хотите удалить аккаунт?",
        "removingApproved": "Запрос на удаление аккаунта успешно отправлен!",
        "recoverApproved": "Запрос на отмену удаления аккаунта успешно отправлен!",
        "accountActionWait": "Подождите...",
        "removeAccountDescription": "Нажимая эту кнопку, Вы подтверждаете, что ваши данные будут удалены безвозвратно через 14 дней. После этого восстановить аккаунт будет невозможно.",
        "emptyReferrals": "Вы пока никого не приглашали!",
        "status-accepted": "Приглашён",
        "status-pending": "В ожидании...",
        "status-gifted": "Вознаграждение получено",
        "status-taken": "Приглашение отклонено в пользу другого",
        "close": "Закрыть",
        "yourReferrals": "Ваши рефералы",
        "reInvite": "Отправить заново",
        "inviteSent": "Приглашение по адресу {{email}} отправлено",
        "inviteError": "Произошла ошибка при отправке приглашения. Это может быть вызвано разными причинами, возможно, данный пользователь уже зарегистрирован.",
        "header": "Профиль",
        "assistDescription": "Получайте свежие новости и советы от продвинутого ассистента",
        "endSubscriptionDate": "Окончание действия подписки:",
        "endFreeSubscriptionDate": "Пробный период закончится:",
        "buySubscription": "Оформить подписку",
        "subscriptionManagement": "Управление подпиской",
        "upgradeSubscription": "Обновить план",
        "extendSubscription": "Продлить подписку",
        "cancelSubscription": "Отменить подписку",
        "comingSoon": "Уже совсем скоро...",
        "soon": "Уже скоро...",
        "name": "Имя",
        "position": "Должность",
        "industry": "Сфера деятельности",
        "login": "Логин",
        "subscription": "Подписка до",
        "no": "Нет",
        "yes": "Да",
        "lang": "Язык генерации",
        "gender": "Пол",
        "male": "Мужчина",
        "female": "Женщина",
        "other": "Другое",
        "timeZone": "Часовой пояс",
        "organizationTitle": "Организация",
        "buttons": {
            "share": "Поделиться",
            "reshare": "Перепривязать",
            "link": "Привязать",
            "unlink": "Отвязать",
            "pages": "Страницы",
            "help": "Помощь",
        },
        "linkAccount": "Привязать аккаунт",
        "linkedInError": "Перепривяжите аккаунт",
        "inviteFriend": "Пригласи друга:",
        "invite": "Пригласить",
        "timeZoneModalTitle": "Часовые пояса",
        "inviteModalTitle": "Приведи друга и получи полмесяца бесплатно!",
        "timeZoneModalText": `
        Мы внедрили возможность выбора часового пояса (например, UTC+5) специально для вашего удобства, чтобы Вы могли более точно настраивать время публикации своих отложенных постов. Это поможет лучше ориентироваться на аудиторию в нужном регионе и добиться максимального охвата.
        <br>
        <b>Рекомендуемое время для публикаций в linkedIn:</b>
        \t•\tПонедельник: с 8: 00 до 10: 00
        \t•\tВторник: с 9: 00 до 12: 00
        \t•\tСреда: с 10: 00 до 12: 00
        \t•\tЧетверг: с 9: 00 до 11: 00
        \t•\tПятница: с 9: 00 до 12: 00
        <br>
        <b>Пример использования:</b>
        Если Вы находитесь в Казахстане (UTC+5) и хотите публиковать контент для аудитории в США (например, в Нью-Йорке, UTC-5), просто укажите соответствующий часовой пояс. Это позволит вашим постам появляться в 9: 00 утра по времени Нью-Йорка, когда аудитория наиболее активна.
        <br>
        <b>Основные страны и смещения по UTC:</b>
        <b>Азия</b>
        \t•\tКазахстан (Алматы): UTC+5
        \t•\tКитай (Пекин): UTC+8
        \t•\tИндия (Нью-Дели): UTC+5: 30
        \t•\tЯпония (Токио): UTC+9
        \t•\tЮжная Корея (Сеул): UTC+9
        \t•\tИндонезия (Джакарта): UTC+7
        <b>Африка</b>
        \t•\tЮжно-Африканская Республика (Йоханнесбург): UTC+2
        \t•\tЕгипет (Каир): UTC+2
        \t•\tНигерия (Лагос): UTC+1
        \t•\tКения (Найроби): UTC+3
        \t•\tМарокко (Рабат): UTC+0
        <b>Латинская Америка</b>
        \t•\tБразилия (Сан-Паулу): UTC-3
        \t•\tАргентина (Буэнос-Айрес): UTC-3
        \t•\tМексика (Мехико): UTC-6
        \t•\tКолумбия (Богота): UTC-5
        \t•\tЧили (Сантьяго): UTC-3
        <b>Европа</b>
        \t•\tВеликобритания (Лондон): UTC+0
        \t•\tГермания (Берлин): UTC+1
        \t•\tФранция (Париж): UTC+1
        \t•\tИталия (Рим): UTC+1
        \t•\tИспания (Мадрид): UTC+1
        <b>Северная Америка</b>
        \t•\tСША (Нью-Йорк, Восточное время): UTC-5
        \t•\tСША (Лос-Анджелес, Тихоокеанское время): UTC-8
        \t•\tКанада (Торонто): UTC-5
        \t•\tКанада (Ванкувер): UTC-8
        <br>
        Обратите внимание, что некоторые страны имеют несколько часовых поясов. Если Вы работаете с аудиторией из другой страны, рекомендуем уточнить нужное смещение по UTC для оптимального времени публикации. 
        Проверяйте локальное время через сервисы вроде timeanddate.com.
        <br>
        Настройте свой часовой пояс и привлеките максимум внимания своей аудитории! 😊
      `,
        "inviteModalText": `
      Хочешь получить дополнительные дни пользования сервисом бесплатно?<br>
      Просто пригласи друга! Вот как это работает:
      <ol>
      <li><b>1. Поделитесь контактами:</b> Укажите почту друга, которому может быть интересен наш сервис.</li>
      <li><b>2. Мы отправим письмо:</b> Мы напишем вашему другу письмо (Вас укажем в копии), где расскажем о нашем сервисе и о том, что Вы его пригласили. Так Ваш друг точно будет знать, что это не спам или мошенничество.</li>
      <li><b>3. Получите полмесяца бесплатно:</b> Если друг зарегистрируется и оплатит платный тариф, Вам автоматически начислят 15 дней бесплатного доступа к тому же тарифу, который выбрал Ваш друг.</li>
      <li><b>4. Друг получает выгоду:</b> Ваш друг также получит <b>скидку 30% на первый месяц использования</b> сервиса. Здесь выигрывают все!</li>
      </ol>Если у Вас возникнут вопросы, свяжитесь с нами по адресу <a class='text-purple-800' href="mailto:info@diffuz.io">info@diffuz.io</a> — будем рады помочь!
      `,
        "shareGeoDataButtonTitle": "Поделиться местоположением",
        "reShareGeoDataButtonTitle": "Обновить местоположение",
        "sharedGeoDataSuccess": "Вы успешно обновили своё местоположение на сервере DIFFUZ.IO",
        "sharedGeoDataError": "Произошла ошибка при обновлении местоположения на сервере DIFFUZ.IO",
        "selectFacebookPage": "Выберите Facebook страницу",
        "selectLinkedInPage": "Выберите LinkedIn страницу",
        "helpForFacebook": "Помощь с Facebook",
        "fbPagesInfoLinking": "Чтобы связать ваш Facebook-аккаунт с нашим сервисом, убедитесь, что у вас есть Страница Facebook, а не только личный Профиль.\n" +
            "<br/>\n" +
            "<br/>\n" +
            "Как создать страницу, у нас в разделе \"Полезные советы\" главного окна есть подсказка.",
        "helpForInstagram": "Помощь с Instagram",
        "instInfoLinking": "Чтобы связать ваш Instagram-аккаунт с нашим сервисом, убедитесь, что у вас есть бизнес-аккаунт Instagram." +
            "<br/>\n" +
            "<br/>\n" +
            "Как создать бизнес-аккаунт, у нас в разделе \"Полезные советы\" главного окна есть подсказка.",
        "nameHint": "Отображается в сгенерированных постах и подписях",
        "readonly": "только для чтения",
        "status": {
            "connected": "Подключено",
            "notConnected": "Не подключено",
            "linkedNoDetails": "Аккаунт подключен (данные недоступны)"
        },
        "tip": {
            "linkBenefits": "Подключите аккаунт, чтобы планировать публикации и получать аналитику.",
            "managePages": "Управляйте подключёнными страницами для публикаций."
        },
        "timeZoneHint": "Используется для планирования и дедлайнов",
        "unlinkLinkedinConfrimTitle": "Отвязка LinkedIn",
        "unlinkFacebookConfrimTitle": "Отвязка Facebook",
        "unlinkInstagramConfrimTitle": "Отвязка Instagram",
        "unlinkThreadsConfirmTitle": "Отвязка Threads",
        "successOauth": "Аккаунт {{provider}} подключён",
        "authError": "Ошибка при авторизации в {{provider}}: {{error}}",
        "authFailed": "Не удалось завершить авторизацию {{provider}}",
    },
    "subscriptionPlans": {
        "header": "Тарифы",
        "Strategy": "Стратегии",
        "ContentPlan": "Контент планы",
        "LeadingQuestions": "Наводящие вопросы",
        "Post": "Посты",
        "Theme": "Темы",
        "PostImages": "Изображения постов",
        "free": "Бесплатный",
        "paid": "Премиум",
        "assistant": "Продвинутый ассистент",
        "infoButton": "Описание функционала",
        "promoCodeTitle": "Промо-код",
        "havePromoCode": "Есть промо-код?",
        "promoCodeError": "Неверный промо-код или срок акции истёк",
        "modalTitle": "Функционал сервиса DIFFUZ.IO:",
        "modalText": `
        Diffuzio поможет Вам легко и эффективно создавать публикации для LinkedIn, Facebook, Instagram с помощью искусственного интеллекта. Наш сервис предлагает:
        
        <b>- Создание постов с ИИ:</b>
        Наш сервис использует передовые алгоритмы искусственного интеллекта, чтобы генерировать уникальный контент, который соответствует вашей профессиональной личности и целям. Вы получаете посты, адаптированные к вашему стилю, аудитории и ключевым темам вашей сферы деятельности. Это позволяет выделяться среди конкурентов и формировать личный бренд.
        
        <b>- Мгновенный и Отложенный постинг:</b>
        Вы можете публиковать свои посты на LinkedIn, Facebook, Instagram сразу или запланировать их на более удобное время. Планирование публикаций позволяет организовать регулярную активность на платформе, даже если Вы заняты. Благодаря этой функции Вы охватываете свою аудиторию в наиболее подходящее время, повышая эффективность и вовлеченность.
        
        <b>- Ассистент-помощник:</b>
        Наш интеллектуальный помощник готов ответить на ваши вопросы, помочь с формированием идей для публикаций, перевести текст на другой язык, подготовить деловые письма и даже подсказать стратегии взаимодействия с вашей аудиторией. Общайтесь с ним в формате диалога, как с личным консультантом, который всегда под рукой. Более того, Вы можете попросить ассистента написать пост и сразу опубликовать его в LinkedIn, Facebook, Instagram, экономя ваше время и упрощая процесс публикации.
        
        <b>- Голосовой ввод:</b>
        Забудьте о необходимости печатать — просто говорите, и наш сервис преобразует ваши слова в текст. Эта функция особенно удобна, если у Вас мало времени или Вы хотите зафиксировать идею на ходу. Голосовой ввод работает быстро и точно, позволяя Вам сосредоточиться на содержании, а не на наборе текста."
      `,
        "submit": "Понятно",
        "unlimitedRate": "Безлимитный функционал",
        "assistantRate": "Безлимитный функицонал + личный ИИ ассистент",
        "freeRate": "Бесплатный пробный период на 14 дней",
        "active": "Активный",
        "offerExpire": "Предложение закончится",
        "offerOver": "Предложение закончилось",
        "subscribeExpired": "Подписка закончилась",
        "subscribeExtended": "Подписка успешно продлена!",
        "rememberMyCard": "Запомнить карту",
        "rememberMyCardPopoverTitle": "Подсказка для пользователей при оплате",
        "rememberMyCardPopoverText": "Для вашего удобства, отметив галочку в чекбоксе, вы можете сохранить карту и не вводить её повторно при следующих платежах. Мы не храним и не обрабатываем данные вашей карты — этот процесс выполняет FreedomPay, международная платформа обработки платежей, обеспечивающая безопасность и защиту транзакций.\n" +
            "\n" +
            "Если у вас нет карты под рукой, вы можете оплатить с помощью Apple Pay, Google Pay или Samsung Pay. В этом случае галочку для сохранения карты можно не отмечать.",
        "removeMyCardBtn": "Удалить карту",
        "cardDeleted": "Карта успешно удалена!",
        "cardDeleteError": "Ошибка сервера при удалении карты!",
        "confirmDeleteCard": "Вы действительно хотите удалить свою платежную карту?",
        "confirmExtendSubscribe": "Подтвердите продление подписки",
    },
    "publicationCalendar": {
        "loading": "Загрузка данных...",
        "today": "Сегодня",
        "navigationTitles": {
            "past60": "-2мес.",
            "past30": "-1мес.",
            "past10": "-10дн.",
            "past7": "-1нед.",
            "past5": "-5дн.",
            "past3": "-3дн.",
            "past1": "-1дн.",
            "future1": "+1дн.",
            "future3": "+3дн.",
            "future5": "+5дн.",
            "future7": "+1нед.",
            "future10": "+10дн.",
            "future30": "+1мес.",
            "future60": "+2мес.",
        },
        "postStatuses": {
            "published": "Пост успешно опубликован!",
            "error": "Ошибка публикации:",
            "pending": "В ожидании публикации...",
        },
        "postTypes": {
            "personal": "(личный)",
            "quickPersonal": "Мгновенный пост",
            "planPersonal": "Пост из контент-плана",
            "quickEmployee": "Мгновенный пост (сотрудник)",
            "planEmployee": "Пост из контент-плана (сотрудник)",
            "other": "Другой тип"
        },
        "goToPost": "Перейти в пост",
        "legend": "Легенда",
        "contentTypes": {
            "contentPlan": "Пост из контент-плана",
            "quickPost": "Мгновенный пост"
        },
        "noPosts": "Нет постов",
        "filters": {
            "byUser": "Фильтр по пользователю:",
            "selectUser": "Выберите пользователя",
            "allUsers": "Все пользователи"
        },
        "toolbar": {
            "today": "Сегодня",
            "past": "Прошедшие:",
            "future": "Будущие:",
            "view": "Вид:",
            "viewOptions": {
                "day": "День",
                "week": "Неделя",
                "month": "Месяц",
                "year": "Год",
                "custom": "Произвольно"
            }
        },
        "messages": {
            "loadingPosts": "Загрузка постов…",
            "noPosts": "Нет постов",
            "failedDragNote": "Не удалось перенести заметку",
            "failedDragPost": "Не удалось переместить пост",
            "cantDragPublished": "Опубликованные посты не могут быть перемещены.",
            "cantDragToPast": "Публикации нельзя перемещать в прошедшие дни",
            "cantCreatePostInPast": "Нельзя создавать посты в прошлом",
        },
        "legendLabels": {
            "quickPersonal": "Мгновенный пост (личный)",
            "plannedPersonal": "Пост из контент-плана (личный)",
            "quickEmployee": "Мгновенный пост (сотрудник)",
            "plannedEmployee": "Пост из контент-плана (сотрудник)"
        },
        "actions": {
            "createPost": "Создать пост",
            "createNote": "Создать заметку",
        },
        "noteModal": {
            "title": "Новая заметка",
            "titleEdit": "Редактирование заметки",
            "deleteCards": {
                "title": "Удалить заметку?",
                "description": "Это действие нельзя отменить",
            },
            "fields": {
                "selectedDate": "Дата",
                "title": "Заголовок",
                "description": "Описание",
            },
            "buttons": {
                "create": "Создать",
                "cancel": "Отмена",
                "save": "Сохранить",
                "delete": "Удалить",
            },
            "placeholders": {
                "title": "Например: Идея для поста",
                "description": "Краткое содержание…",
            },
            "messages": {
                "success": "Заметка создана",
                "failed": "Не удалось создать заметку",
                "updated": "Заметка обновлена",
                "delete": "Заметка удалена",
            },
            "errors": {
                "titleRequired": "Укажите заголовок",
                "deleteNote": "Не удалось удалить заметку",
            },
        },
    },
    "survey": {
        "survey": "Опрос",
        "recording": "Запись голоса.. Нажмите чтобы остановить запись",
        "type": "или напишите свой ответ здесь...",
        "wait": "Пожалуйста, подождите, мы сохраняем ваши ответы и генерируем информацию. ",
        "clear": "Очистить",
        "submit": "Далее",
        "tapToStart": "Нажмите, чтобы продиктовать Ваш ответ",
        "title": "Пожалуйста, заполните данные для создания контента",
        "inputLabelName": "Как Вас зовут?",
        "inputPlaceholderName": "Введите Ваше имя",
        "inputInfoName": "Данное имя будет использоваться в контенте",
        "inputLabelIndustry": "Отрасль",
        "inputPlaceholderIndustry": "Отрасль в которой Вы работаете",
        "inputInfoIndustry": "Если Ваша отрасль отсутствует в списке, Вы можете ввести её вручную",
        "inputLabelPosition": "Должность",
        "inputPlaceholderPosition": "Ваша должность",
        "inputInfoPosition": "Если Ваша должность отсутствует в списке, Вы можете ввести её в ручную",
        "textLabelWorkExperienceAndSkills": "Опыт работы и ключевые навыки",
        "textPlaceholderWorkExperienceAndSkills": "Краткое описание опыта работы, ключевые навыки и компетенции, а также проекты, которыми Вы гордитесь.",
        "textLabelPersonalityHobby": "Личные интересы и увлечения",
        "textPlaceholderPersonalityHobby": "Информация о хобби и интересах, которые можно включить в посты, чтобы сделать их более человечными и аутентичными.",
        "textLabelSocialActivity": "Социальная активность и участие в сообществах",
        "textPlaceholderSocialActivity": "Информация о группах или сообществах, в которых Вы активно участвуете (например, профсоюзы, волонтерство, профессиональные группы).",
        "textLabelShortGoals": "Краткосрочные карьерные цели (на 1-2 года)",
        "textPlaceholderShortGoals": "Определение ближайших профессиональных целей, которые Вы хотите достичь в краткосрочной перспективе. Это может быть повышение в должности, освоение новых навыков или успешное завершение крупных проектов.",
        "textLabelLongGoals": "Долгосрочные карьерные цели (через 3-5 лет)",
        "textPlaceholderLongGoals": "В каком направлении Вы хотите развиваться в более длительной перспективе. Какие роли или позиции видите для себя в будущем. Эти цели помогают фокусироваться на стратегических шагах для достижения этих карьерных устремлений.",
        "textLabelUniqueTradeRelations": "Уникальное торговое предложение (УТП)",
        "textPlaceholderUniqueTradeRelations": "Чем Вы отличаетесь от других профессионалов в своей области. Это могут быть уникальные навыки, подходы или достижения, которые делают Вас ценным специалистом на рынке труда.",
        "textLabelAchievements": "Награды и достижения",
        "textPlaceholderAchievements": "Профессиональные награды, признания, сертификаты или похвалы от коллег и руководства, которые подчеркивают опыт и вклад в отрасль. Это может включать успешные проекты, лидерство или инновационные решения.",
        "textLabelProjects": "Проекты и инициативы в процессе реализации",
        "textPlaceholderProjects": "Информация о текущих проектах или инициативах, над которыми Вы работаете, и которые могут быть интересны для аудитории. Это показывает активность и вовлеченность в профессиональную среду.",
        "textLabelStrongSides": "Ваши уникальные сильные стороны",
        "textPlaceholderStrongSides": "Ключевые компетенции, сильные навыки и личные качества, которые помогают Вам успешно выполнять свою работу и преуспевать в своей профессиональной деятельности. Это может включать лидерские качества, умение решать сложные задачи, коммуникационные навыки и др.",
        "textLabelWeakSides": "Слабые стороны",
        "textPlaceholderWeakSides": "Те аспекты, которые Вы считаете своими зонами для роста или улучшения. Это могут быть пробелы в навыках или областях знаний, над которыми Вы хотите работать в будущем, чтобы стать более эффективным специалистом",
        "selectLabelExperience": "Уровень опыта",
        "selectPlaceholderExperience": "Выберите Ваш уровень опыта",
        "checkboxLabelThemes": "Темы для обсуждения",
        "checkboxLabelGoalsPublicLinkedIn": "Цели публикации в социальных сетях",
    },
    "home": {
        "welcomeBack": "Добро пожаловать, ",
        "logout": "Выйти",
        "logoutConfirm": "Вы действительно хотите выйти из аккаунта?",
        "support": "Техническая поддержка",
        "postsCalendar": "Календарь публикаций",
        "guideline": "Полезные советы",
        "homeNavTitle": "Главная",
        "contentPlanNavTitle": "Контент-план",
        "createPostNavTitle": "Быстрые публикации",
        "personalAssistantNavTitle": "Ассистент",
        "strategyNavTitle": "Стратегия",
        "contentPlan": "Создать контент-план",
        "personalAssistant": "Персональный ассистент",
        "moderation": "Модерация",
        "alertsManagement": "Управление оповещениями",
        "achievements": "Достижения",
        "myAchievements": "Мои достижения",
        "strategy": "Цифровая стратегия",
        "createPost": "Создать публикацию",
        "formatPost": "Формат публикации",
        "linkSocials": "Привязать соц. сети",
        "profile": "Профиль",
        "personalBrandStrategy": "Публичный образ человека, ведущего профессиональную деятельность, который возникает в сознании целевой аудитории",
        "profileTitle": "Информация о профиле, Ваших подписках, приглашенных друзьях",
        "contentPlanTitle": "Здесь хранится информация о будущих постах",
        "createPostTitle": "Здесь Вы можете быстро создать и сразу опубликовать пост",
        "assistantTitle": "В режиме диалога Ваш личный помощник: перевести текст, написать письмо и многое другое",
        "strategyTitle": "Здесь создается стартегия для Вас",
        "moderationTitle": "Здесь Вы можете управлять постами других пользователей",
        "role": "Амбассадор",
        "friend": "Друг",
        "welcome": "Добро пожаловать",
        "useYourInnerVoice": "ОДИН ПОСТ. СОТНИ ГОЛОСОВ. ТЫСЯЧИ ИСТОРИЙ.",
        "publicationCalendar": "Календарь публикаций",
        "publicationCalendarDesc": "Планируй и отслеживай свои публикации в удобном календаре.",
        "instantPost": "Мгновенный пост",
        "instantPostDesc": "Оставайся на связи и публикуй без задержек.",
        "contentPlanLong": "Эффективно планируй контент и меняй процесс работы.",
        "personalAssistantDesc": "Твой умный ассистент для быстрых и точных решений, основанных на данных.",
        "moderationDesc": "Упрощай коммуникацию и усиливай командное взаимодействие.",
        "analytics": "Аналитика",
        "analyticsDesc": "Отслеживай ключевые метрики и понимай тенденции с аналитикой.",
        "subscriptionDaysLeft": "Количество дней до окончания подписки: {{days}}",
        "logoutTitle": "Подтверждение выхода",
    },
    "personalBrand": {
        "needSurveyText": "Для более точного создания Вашего контента необходимо пройти опрос",
        "coffee": `Это может занять 5-7 минут.\r\nКак насчёт чашечки бодрящего кофе для вдохновения пока формируется стратегия?`,
        "header": "Цифровая стратегия",
        "newStrategy": "Создать новую стратегию",
        "Name": "Имя",
        "Occupation/Title": "Заголовок",
        "Short Bio": "Короткое описание",
        "Accolades & Awards": "Награды",
        "Strengths": "Сильные стороны",
        "Weaknesses": "Область для улучшения",
        "Passions": "Увлечения",
        "Values": "Ценности",
        "What Sets You Apart": "Что отличает вас",
        "Unique Benefits You Can Provide": "Уникальные преимущества, которые Вы можете предоставить",
        "Determine Who You are Trying to Reach and Communicate With": "Целевая аудитория",
        "Understand Their Needs, Wants, and Challenges": "Понять их потребности, желания и проблемы»: «Понять их потребности, желания и проблемы",
        "How Should Daniel Address These Needs and Challenges": "Как {{username}} следует решать эти нужды и решать проблемы",
        "Colors": "Цвета",
        "Imagery": "Образы",
        "Personal Logo or Signature": "Личный логотип или подпись",
        "Areas of Expertise": "Области знаний",
        "Content Formats": "Форматы контента",
        "Content Themes": "возможные темы контента",
        "Engagement Strategy": "Стратегия взаимодействия",
        "Short-term Goals (1-2 years)": "Краткосрочные цели (1-2 года)",
        "Long-term Goals (3-5 years)": "Долгосрочные цели (3-5 лет)",
        "Feedback Channel": "Канал обратной связи",
        "Adaptation Strategy": "Стратегия адаптации",
        "Conclusion": "Заключение",
    },
    "sendPassword": {
        "header": "Забыли пароль",
        "title": "Пожалуйста, введите свой адрес электронной почты, чтобы получить ссылку для смены пароля.",
        "placeholder": "Адрес электронной почты",
        "sendCode": "Отправить ссылку",
        "return": "Назад"
    },
    "newPassword": {
        "wrongEmail": "Некорректный адрес электронной почты.",
        "noMatch": "Пароли не совпадают.",
        "header": "Создать новый пароль",
        "passwordRequirements": "Убедитесь, что Ваш пароль содержит не менее 8 символов: 1 заглавную, 1 строчную, 1 цифру и 1 специальный символ.",
        "placeholderCreate": "Создать новый пароль",
        "placeholderConfirm": "Подтвердите пароль",
        "continue": "Продолжать"
    },
    "post": {
        "titlePage": "Написать Пост",
        "improveBut": "Улучшить",
        "saveBut": "Сохранить",
        "showMore": "еще",
        "rollUp": "свернуть",
        "textToGenerateAnotherPost": "Напиши похожий либо продолжение к этому посту",
        "at": "в",
        "needSurveyText": "Для более точной генерации постов необходимо пройти опрос",
        "needSurveyRepeatText": "Для последующих генераций моментальных постов необходимо пройти опрос который поможет Вам генерировать более качественные посты",
        "leadingQuestions": "Наводящие вопросы",
        "noLeading1": "Для данного контент-плана нет наводящих вопросов",
        "noLeading2": "Если Вы сейчас не знаете о чем написать, нажмите кнопку “Создать” наводящие вопросы и, возможно, ответы на них помогут Вам с направлением публикации. Иначе - проигнорируйте.",
        "loading": "Загрузка...",
        "generate": "Генерировать",
        "headerPost": "Пост",
        "headerCreate": "Создать пост",
        "suggestion": "Предложения по посту",
        "published": "Опубликовано",
        "notpublished": "Не опубликован",
        "broken": "Ошибка",
        "planned": "Опубликуется:",
        "hashtagSuggestion": "Предложения по хештегам",
        "mediaSuggestion": "Рекомендации к визуалу",
        "image": "Медиа файлы",
        "noImage": "Нет медиа файлов!",
        "noImageInfoNotDrag": "Перетащите файл(ы) сюда или нажмите для выбора",
        "noImageInfoWithDrag": "Отпустите для загрузки",
        "bigFileSize": "Слишком большой размер файла. Пожалуйста, выберите другое изображение до 10мб",
        "bigMediaListSize": "Суммарный вес медиа файлов превышает {{size}}мб. Пожалуйста, выберите другие медиа файлы, суммарным размером до {{size}}мб.",
        "maxVideoSize": "Слишком большой размер файла. Пожалуйста, выберите другое видео до 300мб",
        "uploadImage": "Загрузить изображение",
        "save": "Сохранить",
        "processingImage": "Пожалуйста, подождите, мы обрабатываем изображение",
        "generateImage": "Создать изображение",
        "generatingImage": "Генерируем изображение",
        "generating": "Мы генерируем Ваш пост",
        "pdf": "Скачать PDF",
        "remove": "Удалить",
        "addVideo": "Загрузить видео",
        "removeVideo": "Удалить видео",
        "removeImages": "Удалить изображения",
        "removeSingleMediaConfirm": "Вы уверены, что хотите удалить этот медиа файл?",
        "removeAllMediaConfirm": "Вы уверены, что хотите удалить все медиа файлы?",
        "maxVideoDuration": "Максимальная длительность видео - 10 минут",
        "dragActive": "Перетащите файл(ы) сюда или нажмите для выбора",
        "onDrag": "Отпустите для загрузки",
        "dragInfo": "Вы можете загрузить медиа файлы: видео до 200мб и продолжительность до 10минут и изображения размером до 8мб (для каждого изображения)",
        "notificationFilesForPlatformsTitle": "Рекомендации к изображениям",
        "notificationFilesForPlatformsDescription": "В связи с тем, что разные социальные сети выставляют свои рекомендации к изображениям, ниже приведена информация о рекомендациях к изображениях для каждой платформы:\n" +
            " \n" +
            "LinkedIn\n" +
            "​•​Рекомендуемый размер: 1200 x 627 пикселей (соотношение 1.91:1).\n" +
            "​•​Минимальный размер: 552 x 368 пикселей.\n" +
            "​•​Максимальный размер: 7680 x 4320 пикселей.\n" +
            " \n" +
            "Facebook\n" +
            "​•​Рекомендуемый размер: 1200 x 630 пикселей.​\n" +
            "​•​Рекомендуемый размер: ширина не менее 630 пикселей.\n" +
            " \n" +
            "Instagram\n" +
            "​•​Рекомендуемый размер: 1080 x 1080 пикселей.\n" +
            "​•​Квадратное изображение: 1080 x 1080 пикселей (1:1).\n" +
            "​•​Портрет: 1080 x 1350 пикселей (4:5).\n" +
            "​•​Ландшафт: 1080 x 566 пикселей (1.91:1).\n" +
            " \n" +
            "Важно: Требования социальных сетей к публикациям в том числе и изображений могут меняться, поэтому рекомендуется обращать внимание на статус публикаций поста.",
        "postGenerateImageLimit": "Максимальное количество генераций изображений на пост 3 попытки.",
        "postGenerateImageLeft": "У Вас осталось попыток:",
        "selectSocialsMedia": "Выберите социальные сети",
        "apply": "Применить",
        "visibleLogoTitle": "Отображать логотип",
        "logoScales": {
            "SM": "Маленький",
            "MD": "Средний",
            "LG": "Большой",
        },
        "logoPositions": {
            "TOP_LEFT": "Вверху слева",
            "TOP_RIGHT": "Вверху справа",
            "BOTTOM_LEFT": "Внизу слева",
            "BOTTOM_RIGHT": "Внизу справа",
            "LEFT": "Слева",
            "RIGHT": "Справа",
            "CENTER": "По центру",
            "TOP": "Вверху",
            "BOTTOM": "Внизу",
        },
        "videoToInstagramInfo": "Видео можно загружать только в Instagram. Пожалуйста, используйте формат \"В основном совместимый\".",
        "videoOrImagesOnly": "Reels поддерживает только видео. Включайте только изображения или видео.",
        "publishingInProgress": "Публикуется",
    },
    "contentPlan": {
        "header": "Контент-план",
        "week": "Неделя",
        "add": "Нажмите + для выбора социальных сетей",
        "selectNetworks": "Выберите социальные сети",
        "frequency": "Частота",
        "elementsTitle": "Выберите или добавьте элементы для контента этой недели",
        "custom": "Напишите здесь свои запросы на индивидуальный контент",
        "create": "Создать контент план",
        "tokenError": "Для генерации необходимо привязать хотя бы одну социальную сеть",
        "strategyError": "У Вас не сгенерирована личная стратегия",
        "needSurveyText": "Для создания контент плана необходимо пройти опрос",
        "goToSurveyBtnText": "Пройти опрос",
        "selectWeekDaysTitle": "Выберите на какие дни недели сгенерировать контент",
        "brands": {
            "instagram": "Instagram",
            "linkedin": "LinkedIn",
            "facebook": "Facebook"
        },
        "readiness": "Статус готовности",
        "readyToPublish": "Готов к публикации",
        "notReadyHint": "Контент-план не готов",
        "previewCompanyPage": "Страница компании",
        "previewBusinessPage": "Бизнес-страница",
        "emptyAlt": "Пустой контент-план",
        "languages": {
            "russian": "на русском языке",
            "english": "на английском языке"
        },
        "statusDraftSaved": "Черновик сохранён {{when}}",
        "autoSaveOn": "Автосохранение включено",
    },
    "organization": {
        "managedByOrganization": "Этим профилем управляет организация",
        "viewFile": "Посмотреть файл",
        "uploadFile": "Загрузить файл",
        "replaceFile": "Заменить файл",
        "replaceLogo": "Заменить логотип",
        "aboutOrganization": "Об организации",
        "contacts": "Контакты",
        "name": "Наименование",
        "establishmentYear": "Дата создания",
        "email": "Эл. Почта",
        "phone": "Телефон",
        "website": "Сайт",
        "address": "Адрес",
        "credentials": "Реквизиты",
        "BANK": "БАНК",
        "BIC": "БИК",
        "BIN": "БИН",
        "IIK": "ИИК",
        "KBE": "КБЕ",
        "generalDirector": "Генеральный директор",
    },
    "camera": {
        "title": "Сделать фото",
        "takePhoto": "Сделать фото",
        "switchCamera": "Переключить камеру",
        "loading": "Загрузка камеры...",
        "permissionDenied": "Доступ к камере запрещен. Пожалуйста, разрешите доступ к камере в настройках браузера.",
        "notFound": "Камера не найдена на этом устройстве.",
        "error": "Ошибка доступа к камере.",
        "photoTaken": "Фото успешно сделано!",
        "captureFailed": "Не удалось сделать фото.",
        "inUse": "Камера уже используется другим приложением.",
        "constraintError": "Камера не поддерживает требуемые параметры.",
        "securityError": "Доступ к камере заблокирован по соображениям безопасности. Используйте HTTPS.",
    },
    "postPage": {
        "cards": {
            "postTitle": "Быстрый пост",
            "platforms": "Платформы",
            "linkAcc": "Свяжите учетные записи",
            "schedule": "Расписание",
            "localTime": "Использует ваше местное время",
            "whatPostSay": "Что должно быть написано в посте?",
            "characters": "Символы",
            "generationOptions": "Настройки генерации",
            "formatPostTitle": "Формат",
            "languagesPost": "Языки",
            "lengthPost": "Длина",
            "emojisPost": "Смайлики",
            "modelPost": "Модель",
            "targetScheduleTitle": "Целевая сеть и расписание",
            "when": "Когда",
            "autoOptimizationTitle": "Авто-оптимизация",
            "postContentTitle": "Текст поста",
            "hashtagsTitle": "Хэштеги",
            "mediaSuggestionsTitle": "Рекомендации по медиа",
            "mediaTitle": "Медиа",
            "mediaRequirementsTitle": "Требования к медиа",
            "mediaRequirementsBody": "Рекомендуемые форматы изображений/видео и ограничения платформ.",
            "bestTimeRecommendations": "Рекомендации по лучшему времени",
            "autoRescheduleOnConflict": "Изменение расписания в конфликте",
            "detailsTitle": "Ваши заметки",
            "tipsTitle": "Советы",
            "orderLabel": "Порядок публикации",
            "reorderModalTitle": "Переставить изображения",
            "collaborators": "Соавторы",
            "mediaCardIsNotAvailable": "Загрузка картинок будет доступна после завершения генерации постов"
        },
        "toolbar": {
            "emojisOptions": {
                "none": "Нисколько",
                "few": "Немного",
                "more": "Побольше",
            },
            "modelOptions": {
                "default": "Оптимальный и гибкий",
                "creative": "Креативный и смелый",
                "formal": "Чёткий и пунктуальный",
            },
        },
        "hint": {
            "hintText": "Краткий и понятный контекст повышает качество. Учитывайте аудиторию и цель.",
            "shortcutSend": "Отправить: Ctrl+Enter",
            "shortcutPaste": "Вставить: Ctrl+V",
            "previewHint": "Предварительный просмотр вашего поста в социальных сетях",
            "reorderHint": "Перетащите картинку, чтобы изменить порядок",
            "collaborators": "Соавторы — это пользователи Instagram, которые будут отмечены как соавторы поста. Эта функция недоступна для Stories. При наличии соавторов можно добавить только одно медиа.",
            "addReferencesFirst": "Можете добавить референсы для более точной генерации",
        },
        "brands": {
            "instagram": "Instagram",
            "linkedin": "LinkedIn",
            "facebook": "Facebook"
        },
        "buttons": {
            "startRecording": "Начать запись",
            "stopRecording": "Остановить запись",
            "copy": "Копировать",
            "save": "Сохранить",
            "edit": "Редактировать",
            "uploadImage": "Загрузить изображение",
            "removeVideo": "Удалить видео",
            "addVideoReels": "Добавить видео (Reels)",
            "generate": "Сгенерировать",
            "removeImages": "Удалить изображения",
            "saveFooter": "Сохранить",
            "publishFooter": "Опубликовать",
            "clear": "Очистить",
            "settings": "Настройки",
            "remember": "Запомнить",
            "refresh": "Обновить",
            "hide": "Скрыть",
            "show": "Показать",
            "stories": "Stories",
            "reorder": "Изменить порядок изображений",
            "cancel": "Отмена",
            "add": "Добавить",
            "referenceImages": "Изображения-референсы",
            "addMoreReferences": "Добавить ещё",
            "addReference": "Добавить референc",
            "takePhoto": "Сделать фото"
        },
        "placeholders": {
            "post": "Напишите что-нибудь вовлекающее…",
            "hashtags": "#маркетинг #b2b #кейс",
            "media": "Предложите визуалы, темы или B-roll…",
            "addDetails": "Добавьте подробности, ключевые моменты, ссылки…",
            "detailsPlaceholder": "Добавьте контекст, ссылки, маркеры…",
            "collaboratorsPlaceholder": "Введите имя пользователя соавтора",
            "collaboratorsNoPlaceholder": "Пока соавторы не добавлены",
            "collaboratorsAddPlaceholder": "Добавьте аккаунты Instagram, чтобы отметить их как соавторов",
            "selectPastCollaborator": "Выберите из прошлых"
        },
        "dropzone": {
            "noImagesYet": "Изображений пока нет",
            "dropFilesToUpload": "Перетащите файлы для загрузки",
            "dragDropOrClick": "Перетащите файлы или нажмите для загрузки",
            "hint": "PNG/JPG до 8 МБ каждый, всего до 80 МБ.",
            "browserNoVideoSupport": "Ваш браузер не поддерживает тег video.",
            "largeTotalWarning": "Большой общий размер медиа — рекомендуется сжать файлы.",
            "noLeadingYet": "Наводящих вопросов пока нет",
        },
        "footer": {
            "draftSaved": "Черновик сохранён минуту назад • Автосохранение включено"
        },
        "misc": {
            "companyPage": "Страница компании",
            "imageLabel": "Изображение"
        },
        "message": {
            "cannotEditPublished": "Опубликованный пост не может быть отредактирован",
            "imgSuccess": "Изображение успешно загружено",
            "imgError": "Ошибка загрузки изображения",
            "imgReorderSuccess": "Порядок обновлён",
            "storiesLimit": "Для Stories можно добавить только одно изображение или видео",
            "imageRemoved": "Изображение удалено",
            "finCrop": "Сначала завершите обрезку изображений",
            "aspectOutRange": "Соотношение {{aspect}} вне диапазона {{min}}–{{max}}. Обрежьте изображение",
            "editCancelled": "Редактирование отменено",
            "finishEditingFirst": "Завершите редактирование перед сохранением",
            "collabLimit": "Максимум {{max}} соавторов. Удалите лишних, чтобы добавить новых",
            "finEditFirst": "Сначала завершите редактирование",
        },
        "imageEditor": {
            "viewImage": "Просмотр изображения",
            "editImage": "Редактировать изображение",
            "edit": "Редактировать",
            "download": "Скачать",
            "downloadImage": "Скачать изображение"
        },
        "micRecorder": {
            "startLabel": "Начать запись",
            "pauseLabel": "Пауза",
            "resumeLabel": "Продолжить",
            "stopLabel": "Отправить",
            "uploadingLabel": "Загрузка",
            "errorMessage": "Не удалось получить доступ к микрофону",
            "emptyTrans": "Пустая транскрипция",
            "errorUpload": "Ошибка при загрузке/распознавании",
            "processingLabel": "Распознаём",
            "cancelLabel": "Отмена",
            "chooseLang": "Выберите язык",
            "start": "Начать запись",
            "serverModeHint": "Запишем аудио и вернём точную транскрипцию.",
            "localModeHint": "Локальное распознавание (быстро, но менее точно).",
            "messages": {
                "unsupported": "Ваш браузер не поддерживает распознавание речи",
                "error": "Ошибка распознавания: {{error}}",
                "unavailable": "Распознавание речи недоступно",
                "startFail": "Не удалось запустить распознавание",
            },
        },
    },
    "imageEditor": {
        "title": "Редактор изображений",
        "social": {
            "title": "Социальные сети",
            "instructionTitle": "Быстрая настройка для соцсетей",
            "instructionDescription": "Выберите платформу для автоматической настройки идеального размера изображения",
            "instagram": {
                "name": "Instagram Post",
                "description": "Квадратный формат для постов"
            },
            "instagramStory": {
                "name": "Instagram Story",
                "description": "Вертикальный формат для сторис"
            },
            "facebook": {
                "name": "Facebook Post",
                "description": "Горизонтальный формат для постов"
            },
            "threads": {
                "name": "Threads Post",
                "description": "Вертикальный формат для Threads"
            },
            "linkedin": {
                "name": "LinkedIn Post",
                "description": "Горизонтальный формат для постов"
            }
        },
        "crop": {
            "title": "Обрезка и поворот",
            "free": "Свободная",
            "square": "Квадрат",
            "instagram": "Instagram",
            "story": "Сторис",
            "landscape": "Пейзаж",
            "portrait": "Портрет",
            "originalSize": "Исходный размер",
            "cropSize": "Размер обрезки",
            "presets": "Пресеты",
            "exit": "Выйти",
            "enter": "Обрезать",
            "apply": "Применить"
        },
        "filters": {
            "title": "Фильтры",
            "none": "Нет",
            "clarendon": "Кларендон",
            "gingham": "Гингем",
            "moon": "Луна",
            "lark": "Жаворонок",
            "reyes": "Рейес",
            "juno": "Юнона",
            "slumber": "Сон",
            "crema": "Крема",
            "ludwig": "Людвиг",
            "aden": "Аден",
            "amaro": "Амаро",
            "mayfair": "Мэйфэйр",
            "rise": "Восход",
            "hudson": "Гудзон",
            "valencia": "Валенсия",
            "xpro2": "X-Pro II",
            "sierra": "Сьерра",
            "willow": "Ива",
            "lofi": "Lo-Fi",
            "inkwell": "Чернила",
            "nashville": "Нэшвилл"
        },
        "adjust": {
            "title": "Коррекция",
            "brightness": "Яркость",
            "contrast": "Контраст",
            "saturation": "Насыщенность",
            "sepia": "Сепия",
            "grayscale": "Черно-белый",
            "blur": "Размытие",
            "hue": "Оттенок",
            "reset": "Сбросить фильтры"
        },
        "text": {
            "title": "Текст",
            "placeholder": "Введите ваш текст...",
            "size": "Размер шрифта",
            "bold": "Жирный",
            "italic": "Курсив",
            "underline": "Подчеркивание",
            "add": "Добавить текст"
        },
        "stickers": {
            "title": "Стикеры",
            "upload": "Загрузить стикер",
            "count": "Добавлено стикеров: {{count}}",
            "instructions": "• Кликните на стикер для выбора<br/>• Перетаскивайте для перемещения<br/>• Выберите стикер и нажмите 'Удалить' для удаления"
        },
        "undo": "Отменить",
        "redo": "Повторить",
        "delete": "Удалить",
        "cancel": "Отмена",
        "save": "Сохранить",
        "rotateLeft": "Повернуть влево",
        "rotateRight": "Повернуть вправо",
        "zoom": {
            "out": "Уменьшить",
            "in": "Увеличить",
            "fit": "По размеру"
        },
        "messages": {
            "loadError": "Ошибка загрузки изображения",
            "cropSuccess": "Изображение успешно обрезано",
            "cropError": "Ошибка при обрезке изображения",
            "saveSuccess": "Изображение успешно сохранено",
            "saveError": "Ошибка при сохранении изображения",
            "stickerAdded": "Стикер успешно добавлен",
            "socialPresetApplied": "Пресет {{platform}} применен. Настройте обрезку при необходимости."
        }
    },
    "functions": {
        "maxTextLength": "Превышено лимит в {{limit}} на максимальное количество символов",
        "minTextLength": "Минимальное количество символов {{limit}}",
        "noText": "Текстовое поле не может быть пустым",
        "newPasswordFail": "Ошибка изменения пароля",
        "copiedFromService": "Скопировано из сервиса",
        "noData": "Нет данных",
        "apply": "Применить",
        "generate": "Создать",
        "generating": "Создание...",
        "successfullyGenerated": "Успешно создано!",
        "successfullyFinished": "Успешно завершено!",
        "successfullyUploaded": "Успешно загружено!",
        "successfullySaved": "Успешно сохранено!",
        "successfullySendToGenerate": "Успешно начат процесс формирования!",
        "wrong": "Что-то пошло не так",
        "loading": "Загрузка...",
        "sending": "Отправка...",
        "microphone": "Ошибка доступа к микрофону. Проверьте свое устройство или дайте разрешение.",
        "generatingPost": "Пожалуйста, подождите, создается пост",
        "generatingContentPlan": "Пожалуйста, подождите, создается контент план",
        "loadingLeading": "Загрузка наводящих вопросов",
        "copied": "Скопировано!",
        "pastedFromClipboard": "Вставлено из буфера обмена!",
        "savingAnswersForStrategy": "Сохранение ответов и создание стратегии",
        "changesSaved": "Изменения сохранены",
        "close": "Закрыть",
        "loggedIn": "Успешно авторизован!",
        "registered": "Успешная регистрация!",
        "incorrectCreds": "Не удалось авторизоваться! Проверьте, пожалуйста, Вашу почту.",
        "limitReached": "Достигнут лимит действий, использовано {{count}} из {{max}} генераций по вашему тарифу",
        "recoveryRequested": "Если адрес электронной почты указан верно, мы отправили на него ссылку для сброса пароля.",
        "newPassword": "Пароль изменен",
        "generatingBrand": "Пожалуйста, подождите, создается стратегия",
        "error": "Ошибка",
        "errorPleaseCallSupport": "Ошибка, пожалуйста свяжитесь с тех.поддержкой.",
        "warning": "Предупреждение",
        "wrongLayout": "Неправильная раскладка, измените язык ввода",
        "maxImages": "Максимальное количество изображений - 6",
        "beta": "Бета",
        "minMediaForInstagramPostMessage": "Для публикации в Instagram необходимо загрузить либо сгенерировать минимум один медиа файл!",
        "characterLimitError": "{{network}} ограничивает максимальное количество символов до ({{limit}})",
        "pleaseEditPost": "Пожалуйста, отредактируйте пост, чтобы он соответствовал ограничениям.",
        "editPost": "Редактировать пост",
        "collapse": "Свернуть",
        "expand": "Развернуть",
        "next": "Далее",
        "previous": "Назад",
        "onThePage": "на странице",
        "copy": "Копировать",
        "continue": "Продолжить",
        "accessAfterAuth": "Доступно только после авторизации!",
        "successfullyMoved": "Успешно перемещено!",
        "selectUser": "Пожалуйста, выберите пользователя",
        "allUsers": "Все пользователи",
        "sortBy": "Сортировать по",
        "date": "Дата",
        "user": "Пользователь",
        "ascending": "По возрастанию",
        "descending": "По убыванию",
        "filterByUser": "Фильтр по пользователю",
        "generateDist": "Сгенерировать",
        "name": "Название",
        "reloadPageMessage": "Генерация занимает больше времени, чем ожидалось. Вы можете обновить страницу.",
        "reloadPage": "Обновить",
        "edit": "Редактировать",
        "searchPosts": "Поиск постов",
        "perImageTooLarge": "Каждое изображение должно быть до 8 МБ",
        "tooManyImages": "Можно загрузить максимум 10 изображений",
        "tooManyImagesLeft": "Осталось слотов: {{left}}",
        "totalImagesTooLarge": "Суммарный размер изображений должен быть до 80 МБ",
        "somethingWentWrong": "Что-то пошло не так",
        "pageSize": "Отображать по",
        "order": "Cортировка",
        "wrongOrderImage": "Не удалось обновить порядок",
        "collaboratorsImageCount": "При наличии соавторов можно добавить только одно медиа.",
        "alreadyExists": "Уже добавлен",
    },
    "socials": {
        "header": "Социальные сети",
        "linkAccounts": "Привяжите аккаунты социальных сетей для возможности авто-постинга"
    },
    "plancard": {
        "generated": "Пост сгенерирован",
        "notGenerated": "Пост не сгенерирован",
        "approved": "Одобрен",
        "notApproved": "Не одобрен",
        "onModeration": "На модерации",
        "publish": "Опубликовать пост",
        "approve": "Одобрить на публикацию",
        "approveAgain": "Опубликовать снова",
        "disapprove": "Отправить на доработку",
        "cancel": "Отменить публикацию",
        "cantCancelPublished": "Пост уже опубликован и не может быть отменён",
        "checkingPublish": "Проверяем статус публикации…",
        "hide": "Скрыть публикацию",
        "hiddeConfrim": "Вы действительно хотите скрыть данную публикацию?",
        "successfullyHidden": "Пост был успешно скрыт!",
        "deleteConfirmTitle": "Подтверждение удаления",
        "deleteConfirmMessage": "Удалить пост и связанный контент-план?",
        "cantDeletePublished": "Нельзя удалить опубликованный пост",
        "postDeleted": "Пост удален",
        "delete": "Удалить пост",
        "hideConfirmTitle": "Подтверждение скрытия публикации",
        "publishing": "Публикуется...",
    },
    "posts": {
        "header": "Посты",
        "generatePost": "Сгенерировать пост",
        "postDescription": "Поделитесь с нами основной идеей или контекстом планируемого поста. Вы можете воспользоваться микрофоном",
        "postDetails": "Подробности",
        "settingsSaved": "Настройки успешно сохранены",
        "postDate": "Дата публикации",
        "publish": "Опубликовать",
        "create": "Создать",
        "cancel": "Отменить",
        "regenerate": "Перегенерировать пост",
        "limit": "Лимит текущего тарифа исчерпан, Вы можете оформить платную подписку, чтобы использовать сервис дальше",
        "unknownError": "Произошла ошибка. Просим Вас обратиться в раздел техподдержки сервиса и описать проблему. Мы приложим все усилия чтобы быстро решить проблему.",
        "notLinked-linkedin": "Привяжите аккаунт LinkedIn для возможности публикации постов",
        "notLinked-facebook": "Привяжите аккаунт Facebook для возможности публикации постов",
        "notLinked-instagram": "Привяжите аккаунт Instagram для возможности публикации постов",
        "notLinked-threads": "Привяжите аккаунт Threads для возможности публикации постов",
        "notSelectedFacebookPage": "Выберите страницу Facebook в своём профиле для публикации постов в Facebook",
        "snErrorMessage": "Пост который вы пытаетесь опубликовать требует привязки социальных сетей которые у вас отсутствуют либо могли отвязаться. Пожалуйста, перейдите в профиль и привяжите социальные сети которые использует данный пост и попробуйте снова.",
        "generatedPost": "Сгенерированный текст поста",
        "goToRate": "Перейти к тарифам",
        "goToProfile": "Перейти к профилю",
        "goToSupport": "Перейти к поддержке",
        "chooseFormatTitle": "Выберите формат публикации",
        "acceptFormat": "Подтвердить",
        "formatExampleText": "Пример",
        "createAnotherPost": "Создать похожий пост",
        "seePost": "Посмотреть пост",
        "formats": "Форматы",
        "languages": "Языки",
        "selectLanguages": "Выберите языки",
        "formatSettings": "Настройки форматирования",
        "formatPublication": "Формат публикации",
        "noTextToFormat": "Нет текста для форматирования",
        "selectAtLeastOneLanguage": "Выберите хотя бы один язык",
        "formatSuccess": "Текст успешно отформатирован",
        "formatError": "Ошибка форматирования текста",
        "postModelTitle": "Модель для формата",
        "modelBasic": "Базовая",
        "modelAdvance": "Продвинутая",
        "selectedLanguages": "Выбранные языки",
        "postLengthTitle": "Длина поста (слова)",
        "postEmojisTitle": "Обилие смаиликов в посте",
        "useEmojisTitle": "Использовать эмодзи",
        "kazGenerateWarningMessage": "Сейчас генерация на казахском языке находится в бета тестировании, но мы работаем над улучшением качества генерации на казахском языке",
        "multiLanguagePostsGeneratePlaceholder": "Выберите языки для генерации мультиязычных постов (Если оставить пустым пост сгенерируется на вашем выбранном в профиле языке)",
        "multiLanguagePostsGenerateTitle": "Генерация мультиязычных постов",
        "multiLanguagePostsGenerateDescription": "Если Вы хотите сгенерировать пост на нескольких языках, выберите языки в поле ниже. \nПри выборе языка учтите порядок, в котором Вы выбираете языки(Пост будет сгенерирован в порфдке выбора Вами языков). \nЕсли оставить поле пустым, пост будет сгенерирован на вашем выбранном в профиле языке.",
        "postStatusesInfoTitle": "Информация по статусам публикаций",
        "postStatusModerated": "Промодерировано",
        "postsListEmptyText": "Список постов пуст, нажмите \"Создать публикацию\" для создания поста",
        "postLanguageModelTitle": "Выбор языковой модели",
        "postModels": {
            "default": "Стандартная",
            "advance": "Продвинутая",
        },
        "memoizeChoice": "Запомнить выбор",
        "noPostsTitle": "Пока нет постов",
        "noPostsHint": "Создайте свой первый пост, чтобы увидеть его здесь.",
        "storiesWithoutCollab": "Для Stories соавторы не доступны",
    },
    "support": {
        "header": "Техническая поддержка",
        "supportCardTitle": "Открыть запрос",
        "sectionTitle": "Раздел",
        "describeTitle": "Опишите проблему",
        "placeholderDescribe": "Что произошло? Шаги для воспроизведения, ожидаемый результат, окружающая среда…",
        "attachmentTitle": "Вложения (изображения или видео)",
        "contactCard": {
            "title": "Контактная информация",
            "hint": "Обычно мы отвечаем в течение 1 рабочего дня.",
        },
        "troubleShooting": {
            "title": "Поиск неисправностей",
            "hint": "Если после выхода нового релиза что-то не так, попробуйте очистить кэш автономного режима и перезагрузить приложение.",
            "alert": {
                "title": "Очистите кэшированные файлы и обновите страницу.",
                "description": "Это приведет к удалению кэшированного пакета пользовательского интерфейса с вашего устройства и перезагрузке страницы.",
                "buttonClear": "Очистить кэш и перезагрузить",
                "footerTip": "Совет: приложите к своему запросу скриншоты или короткую запись экрана для более быстрого решения проблемы.",
            },
        },
        "sectionLabel": "Выберите раздел",
        "messageLabel": "Опишите проблему или предложение",
        "fileLabel": "Прикрепленные файлы",
        "send": "Отправить",
        "uploadFile": "Загрузить файл",
        "removeFile": "Удалить",
        "sections": {
            "home-page": "Главная страница",
            "profile-page": "Профиль",
            "content-plan": "Контент план",
            "publication": "Публикация",
            "personal-assistant": "Персональный помощник",
            "personal-branding": "Персональная стратегия",
        },
        "dropzone": {
            "attachment": "Перетащите сюда или щелкните, чтобы загрузить (до 6 файлов)",
        },
        "buttons": {
            "chooseFiles": "Выберите файлы",
            "clear": "Очистить",
            "send": "Отправить",
            "remove": "Удалить",
        },
        "clearCacheBtnTitle": "Очистить кэш",
        "clearCacheDescription": "Если у вас возникли проблемы с устаревшими данными, нажмите кнопку «Очистить кэш» для обновления информации.",
        "clearCacheSuccess": "Кэш успешно очищен!",
        "ifQuestionGetSupport": "Если у вас возникли вопросы или сложности, обратитесь в <a class='text-primary' href='/support'>Техподдержку</a>.",
    },
    "moderation": {
        "header": "Модерация",
        "postsOnModerationEmpty": "Список актуальных постов на модерацию пуст!",
        "postsOnArchiveEmpty": "Список архивных постов пуст!",
        "onModeration": "На модерации",
        "archive": "Архив",
        "unreadModerationCountMessage": "У вас {{count}} постов на модерацию!",
        "goToModeration": "Перейти к модерации",
        "emptyModerationListTitle": "Нет постов на модерацию",
        "emptyModerationListHint": "Новые посты, требующие проверки, появятся здесь.",
        "emptyArchiveTitle": "Архив пуст",
        "emptyArchiveHint": "Одобренные или отклонённые посты будут отображаться здесь.",
    },
    "hww": {
        "regTitle": "Регистрация в сервисе",
        "regSubtitle": "Зарегистрируйтесь в сервисе",
        "strategyTitle": "Создание стратегии",
        "strategySubtitle": "Пройдите опросник и ИИ предоставит персональную стратегию",
        "planTitle": "Создание контент плана",
        "planSubtitle": "С помощью стратегии ИИ создаст для Вас контент-план",
        "postTitle": "Публикация постов",
        "postSubtitle": "Опираясь на стратегию и контент-план, ИИ подберет оптимальные варианты постов"
    },
    "weekDays": {
        "Monday": "Понедельник",
        "Tuesday": "Вторник",
        "Wednesday": "Среда",
        "Thursday": "Четверг",
        "Friday": "Пятница",
        "Saturday": "Суббота",
        "Sunday": "Воскресенье"
    },
    "months": {
        "January": "Январь",
        "February": "Февраль",
        "March": "Март",
        "April": "Апрель",
        "May": "Май",
        "June": "Июнь",
        "July": "Июль",
        "August": "Август",
        "September": "Сентябрь",
        "October": "Октябрь",
        "November": "Ноябрь",
        "December": "Декабрь"
    },
    "alerts": {
        "createNotification": "Создать уведомление",
        "editNotification": "Редактировать уведомление",
        "hintCreateAlerts": "Создавайте внутренние оповещения и автоматически публикуйте вакансии для выбранных сотрудников.",
        "history": "История",
        "title": "Заголовок",
        "description": "Описание",
        "type": "Тип",
        "theme": "Тема",
        "link": "Ссылка",
        "text": "Текст",
        "fromPostLink": "Ссылка на пост",
        "postText": "Текст поста",
        "status": "Статус",
        "author": "Автор",
        "recipient": "Получатель",
        "createdAt": "Дата создания",
        "actions": "Действия",
        "create": "Создать",
        "update": "Обновить",
        "cancel": "Отмена",
        "postCreatedSuccess": "Пост успешно создан!",
        "postCreatedForUsers": "Пост успешно создан для сотрудника {{employeeName}} в {{socialNetwork}}",
        "enterPostLink": "Введите ссылку на пост",
        "enterPostText": "Введите текст поста",
        "enterTitle": "Введите заголовок уведомления",
        "enterDescription": "Введите описание уведомления",
        "selectType": "Выберите тип уведомления",
        "info": "Инфо",
        "warning": "Внимание",
        "danger": "Важно",
        "selectTheme": "Выберите тему уведомления",
        "alert": "Оповещение",
        "suggestion": "Предложение",
        "createPost": "Создание поста",
        "titleRequired": "Заголовок обязателен",
        "descriptionRequired": "Описание обязательно",
        "typeRequired": "Тип обязателен",
        "themeRequired": "Тема обязательна",
        "employeesRequired": "Список получателей обязателен",
        "createSuccess": "Уведомление успешно создано",
        "editSuccess": "Уведомление успешно обновлено",
        "fetchError": "Ошибка при получении уведомлений",
        "success": "Успешно",
        "error": "Ошибка",
        "createError": "Ошибка при создании уведомления",
        "editError": "Ошибка при обновлении уведомления",
        "yes": "Да",
        "no": "Нет",
        "hideConfirmTitle": "Скрыть уведомление",
        "hideConfirmDescription": "Вы действительно хотите скрыть данное уведомление от пользователей?",
        "hiddenSuccess": "Уведомление успешно скрыто",
        "visibleSuccess": "Уведомление теперь видно пользователям",
        "visibilityError": "Ошибка изменения видимости уведомления",
        "notVisibleTooltip": "Данное уведомление больше не отображается у пользователей",
        "viewNotification": "Просмотр уведомления",
        "viewNotificationTooltip": "Просмотреть детали уведомления",
        "employees": "Сотрудники",
        "newNotificationsCreated": "Созданы новые уведомления",
        "newNotificationsCreatedDesc": "Создано новых уведомлений: {{count}} для добавленных сотрудников",
        "noData": "Нет данных для отображения",
        "prompt": "Дополнительные требования",
        "enterPrompt": "Например, 'Пиши от первого лица', 'Используй профессиональный тон'",
        "cardFormat": {
            "title": "Настройки формата",
            "language": "Язык:",
            "model": "Модель:",
            "length": "Длина:",
            "emojis": "Использовать эмодзи:",
        },
        "buttons": {
            "formattingOptions": "Параметры форматирования",
            "selectAll": "Выбрать всех",
            "clear": "Очистить",
        },
        "placeholder": {
            "title": "Введите короткое название",
            "description": "Что должно быть указано в этом уведомлении?",
            "theme": "Выберите тему",
            "selectEmployees": "Выберите сотрудников",
            "prompt": "Дополнительно: руководство для генерации",
            "link": "Вставьте ссылку на статью или страницу",
            "sourceText": "Вставьте или напишите исходный текст (максимум 2000 символов)",
            "employees": "Выберите сотрудников",
            "language": "Выберите языки",
        },
        "hint": {
            "title": "Введите заголовок (от 2 до 200 символов)",
            "description": "Введите описание (2–2000 символов)",
            "theme": "Пожалуйста, выберите тему",
            "employees": "Выберите хотя бы одного сотрудника",
        },
        "themeOption": {
            "alert": "Уведомление",
            "suggestion": "Указание",
            "createPost": "Создать пост",
        },
        "cardPost": {
            "linkTitle": "Из ссылки:",
            "sourceTextTitle": "Исходный текст:",
            "generatePost": "Сгенерированный пост:",
            "labelPrompt": "Промпт",
        },
    },
    "notifications": {
        "title": "Уведомления",
        "open": "Открыть уведомления",
        "unread": "Непрочитанные уведомления",
        "read": "Прочитанные уведомления",
        "empty": "Нет уведомлений",
        "allEmpty": "Нет уведомлений для отображения",
        "markAsRead": "Отметить как прочитанное",
        "goToPost": "Перейти к посту",
        "postCreationError": "Не удалось создать пост",
        "employeeNoSocials": "Не удалось создать пост для {{employeeName}}. Пожалуйста, убедитесь, что хотя бы одна социальная сеть связана с ним.",
        "types": {
            "info": "Информация",
            "warning": "Предупреждение",
            "danger": "Важное"
        },
        "themes": {
            "alert": "Оповещение",
            "suggestion": "Предложение",
            "create_post": "Новый пост",
        },
        "yourHaveUnreadNotifications": "У Вас есть непрочитанные уведомления"
    },
    "validation": {
        "enterName": "Пожалуйста, введите ваше полное имя",
        "nameValid": "Отлично!",
        "nameRequired": "Пожалуйста, введите ваше полное имя",
        "enterEmail": "Введите ваш email",
        "emailValid": "Email выглядит правильно!",
        "emailInvalid": "Пожалуйста, введите корректный email",
        "emailRequired": "Email обязателен",
        "emailDomainMustContainLetters": "Домен email должен содержать буквы",
        "emailDomainExtensionTooShort": "Расширение домена email слишком короткое",
        "emailDomainExtensionMustContainLetters": "Расширение домена email должно содержать буквы",
        "emailCannotContainConsecutiveDots": "Email не может содержать несколько точек подряд",
        "enterPassword": "Введите ваш пароль",
        "passwordValid": "Пароль выглядит хорошо!",
        "passwordInvalid": "Ваш пароль не соответствует требованиям",
        "passwordRequired": "Пароль обязателен",
        "passwordTooShort": "Пароль должен содержать минимум 8 символов",
        "passwordTooLong": "Пароль должен быть короче 128 символов",
        "passwordNeedsAnUppercase": "Пароль должен содержать хотя бы одну заглавную букву",
        "passwordNeedsALowercase": "Пароль должен содержать хотя бы одну строчную букву",
        "passwordNeedsANumber": "Пароль должен содержать хотя бы одну цифру",
        "passwordNeedsASpecialCharacter": "Пароль должен содержать хотя бы один специальный символ",
        "passwordCannotHaveSpaces": "Пароль не может содержать пробелы",
        "passwordIsTooCommon": "Пароль содержит распространённые комбинации и недостаточно надёжен",
        "fixValid": "Проверьте поля формы",
    },
    "achievements": {
        "goToMyAchievements": "Перейти к моим достижениям",
        "earnedLevel": "Ваш текущий уровень",
        "earnedExperience": "Получено опыта",
        "earnedCoins": "Получено монет",
        "unlockedCountAchievements": "Открыто {{opened}} из {{count}} достижений",
        "completedOnPercent": "Выполнено на {{percent}}%",
        "completedOnCount": "Выполнено {{completed}} из {{count}}",
        "benefits": "Преимущества",
        "fetchingError": "Не удалось получить данные о достижениях. Ошибка соединения с сервером, попробуйте позже",
        "intern": {
            "title": "Интерн",
            "description": "Аккаунт создан - ваше путешествие начинается здесь!"
        },
        "activist": {
            "title": "Активист",
            "description": "10 публикаций за месяц - вы находите свой голос!"
        },
        "inspirer": {
            "title": "Вдохновитель",
            "description": "20 публикаций - ваши вклады вдохновляют других!"
        },
        "ambassador": {
            "title": "Амбассадор",
            "description": "30 публикаций - теперь вы признанный лидер в нашем сообществе."
        },
        "ambassadorplus": {
            "title": "Амбассадор+",
            "description": "40 публикаций и более - вы формируете общение на высшем уровне!"
        }
    },
    "achievementLevel": {
        "Intern": "Интерн",
        "Activist": "Активист",
        "Inspirer": "Вдохновитель",
        "Ambassador": "Амбассадор",
        "AmbassadorPlus": "Амбассадор +",
        "Description": {
            "Intern": "Добро пожаловать! Мы рады, что вы с нами!",
            "Activist": "Ваше влияние становится заметным!",
            "Inspirer": "Впечатляющий уровень влияния в соцсетях",
            "Ambassador": "Вы формируете взгляды других",
            "Ambassadorplus": "Высший ранг"
        }
    },
    "postDistribution": {
        "validation": {
            "selectEmployees": "Пожалуйста, выберите сотрудников.",
            "provideContent": "Пожалуйста, предоставьте контекст (ссылка или текст для генерации)."
        },
        "postDistributionForm": {
            "title": "Заголовок",
            "prompt": "Инструкция / Подсказка",
            "languageLabel": "Язык",
            "employees": {
                "employeesLabel": "Сотрудники",
                "placeholder": "Выберите сотрудников",
                "selectAll": "Выбрать всех",
                "clear": "Очистить",
                "excludedAutopublish": "Исключения автопубликации"
            },
            "placeholder": {
                "enterTitle": "Введите короткое название",
                "enterPrompt": "Что должно включать в себя каждое сообщение? (тон, призыв к действию, ключевые моменты)",
                "chooseLanguage": "Выберите языки",
            },
            "hint": {
                "title": "Введите заголовок (от 2 до 200 символов)",
                "prompt": "Введите описание (2–2000 символов)",
                "language": "Выберите 1–3 языка",
            },
            "linkTab": {
                "title": "Ссылка",
                "label": "Ссылка на источник",
                "placeholder": "Вставьте ссылку на статью или страницу",
            },
            "textTab": {
                "title": "Текст",
                "label": "Исходный текст",
                "placeholder": "Вставьте или напишите исходный текст (максимум 8000 символов)",
            },
        },
        "buttons": {
            "generating": "Генерация…",
            "generate": "Сгенерировать для выбранных",
        },
        "cards": {
            "setupTitle": "Настройка рассылки",
            "editorTitle": "Редактор поста",
            "targetNetworks": "Целевые соцсети",
            "autopublicationPerUser": "Настройки автопубликации",
            "autopublicationUser": "Пользователь",
            "autopublicationAutopublish": "Автопубликация",
            "autopublicationHint": "Настройте автопубликацию для сотрудников. Этот флажок будет использоваться при отправке поста",
            "centralizedMediaStorage": "Медиафайлы для всех",
            "addVideo": "Добавить видео",
            "removeVideo": "Удалить видео",
            "addImages": "Добавить картинки",
            "removeImages": "Удалить картинки",
            "removeSingleImage": "Удалить картинку",
        },
        "hint": {
            "onlyVisualChanges": "Рассылка постов - это инструмент, в котором вы создаете кастомизированные посты для своих амбассадоров.",
            "selectEmployees": "Выберите сотрудников для настройки генерации и публикации",
            "noSocialMedia": "У пользователя не привязана ни одна соцсеть"
        },
        "progress": {
            "elapsed": "Время генерации",
            "prevRun": "Предыдущее время генерации"
        },
        "statusMeta": {
            "queued": "В очереди",
            "active": "Активен",
            "delayed": "Отложен",
            "completed": "Завершен",
            "failed": "Ошибка"
        },
        "contentEditor": {
            "postFor": "Пост для",
            "postTitle": "Название",
            "postBody": "Текст поста",
            "planned": "Запланировано",
            "hashtags": "Хэштеги",
            "mediaSuggestion": "Подсказка для генерации изображения",
            "autopublish": "Автопубликация",
            "sendTo": "Отправить пользователю",
            "sending": "Отправляем пост...",
            "sent": "Отправлено"
        },
        "postDistributionTagName": "Рассылка постов",
        "sendToRecipient": "Отправить пользователю: ",
        "sendingInProgress": "Идёт отправка поста пользователю...",
        "postLanguages": "Языки генерации",
        "characterMinLimitError": "Содержимое поста должно быть не менее 25 символов",
        "characterMaxLimitError": "Содержимое поста слишком большое. Текущий лимит символов: ",
        "hashtagsRequired": "Хэштеги обязательны",
        "fileSizeLimitExceeded": "Файл слишком большой.",
        "submissionSuccess": "Пост успешно отправлен!",
        "submissionFailure": "Не удалось отправить пост.",
        "regenerationSuccess": "Пост успешно сгенерирован заново!",
        "regenerationFailure": "Ошибка при повторной генерации поста!",
        "title": "Заголовок",
        "enterTitle": "Введите заголовок",
        "promptInstruction": "Инструкция для генерации поста",
        "enterDescription": "Введите описание",
        "link": "Ссылка",
        "fromPostLink": "Из поста по ссылке",
        "enterPostLink": "Введите ссылку на пост",
        "text": "Текст",
        "postText": "Текст поста",
        "enterPostText": "Введите текст поста",
        "employees": "Сотрудники",
        "employeesRequired": "Выберите хотя бы одного сотрудника",
        "selectAll": "Выбрать всех",
        "clear": "Очистить",
        "selectOneToThreeLanguages": "Выберите от 1 до 3 языков",
        "selectLanguages": "Выберите языки",
        "regeneratePrompt": "Не понравился пост? Подскажите, что нам сделать!",
        "selectedEmployees": "Выбранные сотрудники"
    },
    "postRegeneration": {
        "postRegenerationPlaceholder": "Введите ваш запрос здесь для более точного результата или оставьте поле пустым. Мы просто перегенерируем публикацию."
    },
    "errors": {
        "notFound": "Упс! Здесь ничего нет",
    },
    "navigations": {
        "backHome": "Вернуться на главную",
    },
    "analytics": {
        "menu": "Аналитика",
        "title": "Instagram аналитика",
        "noAccounts": "Нет подключённых Instagram аккаунтов.",
        "emptyLead": "Подключите бизнес Instagram аккаунт, чтобы увидеть метрики по подписчикам, постам и вовлечённости.",
        "connectAccount": "Подключить аккаунт",
        "account": "Аккаунт",
        "filters": "Фильтры",
        "period": "Период",
        "days7": "7 дней",
        "days30": "30 дней",
        "followers": "Подписчики",
        "followersTotalSub": "Всего",
        "media": "Публикации",
        "mediaTotalSub": "Всего публикаций",
        "likesSum": "Лайки (сумма)",
        "commentsSum": "Комментарии (сумма)",
        "last10Posts": "За последние 10 постов",
        "lastPostsAll": "За последние {{count}} объединённых постов",
        "followersByDay": "Подписчики по дням",
        "posts": "Посты",
        "recentPosts": "Недавние посты",
        "recentPostsAll": "Недавние посты (все аккаунты)",
        "date": "Дата",
        "post": "Пост",
        "likes": "Лайки",
        "comments": "Комментарии",
        "link": "Ссылка",
        "open": "Открыть",
        "noPosts": "Нет постов",
        "refresh": "Обновить",
        "moderatorMode": "Режим модератора",
        "allAccounts": "Все аккаунты",
        "moderatorTag": "Модератор",
        "reach": "Охват",
        "engagement": "Вовлечённые аккаунты",
        "profileViews": "Просмотры профиля",
        "metricFollowers": "Подписчики",
        "metricPosts": "Посты",
        "metricReach": "Охват",
        "metricEngaged": "Вовлечённые",
        "metricProfileViews": "Просмотры профиля",
        "metricSelector": "Метрика",
        "downloading": "Скачиваем...",
        "downloadPdf": "Скачать PDF отчёт",
        "insights": "Insights",
        "total": "Суммарно"
    },
    "mediaInsights": {
        "title": "Инсайты по медиа",
        "periodWeek": "Последние 7 дней",
        "period30d": "Последние 30 дней",
        "back": "Назад",
        "openPost": "Открыть пост",
        "rangeTitle": "Диапазон",
        "likesByDay": "Лайки по дням",
        "commentsByDay": "Комментарии по дням",
        "metrics": {
            "comments": { "title": "Комментарии", "description": "Количество комментариев на вашем посте." },
            "follows": { "title": "Подписки", "description": "Количество новых подписок на аккаунт." },
            "likes": { "title": "Лайки", "description": "Количество лайков на посте." },
            "profile_activity": {
                "title": "Действия в профиле",
                "description": "Сумма всех действий в профиле при взаимодействии с контентом."
            },
            "profile_visits": { "title": "Просмотры профиля", "description": "Количество посещений профиля." },
            "reach": {
                "title": "Охваченные аккаунты",
                "description": "Уникальные аккаунты, увидевшие пост хотя бы один раз (оценка)."
            },
            "saved": { "title": "Сохранения", "description": "Количество сохранений поста." },
            "shares": { "title": "Поделились", "description": "Количество репостов поста." },
            "total_interactions": {
                "title": "Взаимодействия",
                "description": "Лайки, сохранения, репосты и комментарии минус отмены и удалённые."
            },
            "views": { "title": "Просмотры", "description": "Количество показов или воспроизведений поста." }
        }
    },
    "imageGenerator": {
    "title": "Генератор ИИ-изображений",
    "generationSettings": "Настройки генерации",
    "imageStyle": "Стиль изображения",
    "additionalInstructions": "Дополнительные инструкции (опционально)",
    "referenceImages": "Референсные изображения ({{count}}/{{max}})",
    "referenceAlt": "Референс {{number}}",
    "generatedImageLabel": "Сгенерированное изображение:",
    "generatedImageAlt": "Результат генерации",
    "noMediaDescription": "Описание медиа еще не добавлено.",
    "emptyStateHint": "Добавьте референсные изображения и настройте параметры для создания новых визуалов",
    "dragToAddHint": "Перетащите, чтобы добавить в публикацию",
    "defaultInstruction": "Создайте изображение в стиле {{style}} на основе предоставленных референсов. Сосредоточьтесь на чистом, профессиональном визуале.",
    
    "buttons": {
        "copyText": "Копировать текст",
        "edit": "Редактировать",
        "save": "Сохранить",
        "clearAll": "Очистить всё",
        "addMore": "Добавить еще",
        "addReference": "Добавить референс",
        "generateImage": "Сгенерировать изображение",
        "cancel": "Отмена",
        "copyUrl": "Копировать URL",
        "open": "Открыть"
    },
    
    "placeholders": {
        "mediaDescription": "Опишите визуал, темы или стиль, которые вы хотите для генерируемых изображений...",
        "instructions": "Добавьте конкретные инструкции для генерации ИИ-изображений..."
    },
    
    "styles": {
        "modern": "Модерн",
        "minimalist": "Минимализм",
        "realistic": "Реализм",
        "illustration": "Иллюстрация",
        "professional": "Профессиональный"
    },
    
    "errors": {
        "notImageFile": "{{fileName}}: Не графический файл",
        "fileTooLarge": "{{fileName}}: Файл слишком большой (макс. 8 МБ)",
        "maxImagesExceeded": "Максимум {{max}} референсных изображений",
        "noReferenceImages": "Пожалуйста, добавьте хотя бы одно референсное изображение",
        "generationFailed": "Ошибка генерации: {{status}} {{statusText}}",
        "invalidResponse": "Некорректный ответ: отсутствует imageUrl",
        "generationError": "Не удалось сгенерировать изображение"
    },
    
    "copySuccess": "Медиа-предложения скопированы в буфер обмена",
    "copyError": "Не удалось скопировать текст",
    "generateSuccess": "Изображение успешно сгенерировано!",
    "generationCancelled": "Генерация отменена",
    
    "guidelines": {
        "title": "Рекомендации по генерации изображений:",
        "popoverTitle": "Советы по генерации ИИ-изображений",
        "linkText": "Рекомендации",
        "uploadTip": "Загружайте 1-3 референсных изображения для лучших результатов",
        "clarityTip": "Изображения должны быть четкими и хорошо освещенными",
        "sizeTip": "Максимальный размер файла: 8 МБ на изображение",
        "formatsTip": "Поддерживаемые форматы: JPG, PNG, WebP",
        "instructionsTip": "Добавляйте конкретные инструкции для кастомных результатов",
        "dragTip": "Перетащите сгенерированное изображение, чтобы добавить его в публикации"
    }
},
};
